module.exports = __webpack_public_path__ + "img/straight-rail-vertical-backplates-remnants.6ac28ecb.png";